// Friendly, English messages for the sign-in page. Raw Firebase text never reaches the user.
const MESSAGES = {
  'auth/wrong-password': 'Incorrect e-mail or password.',
  'auth/user-not-found': 'Incorrect e-mail or password.',
  'auth/invalid-credential': 'Incorrect e-mail or password.',
  'auth/invalid-email': 'Incorrect e-mail or password.',
  'auth/too-many-requests': 'Too many attempts. Please wait a few minutes or reset your password.',
  'auth/user-disabled': 'This account has been disabled. Please contact the administrator.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
  'app/no-profile': 'Your account is not set up yet. Please contact the administrator.',
  'functions/unauthenticated': 'We could not verify your Google sign-in. Please try again.',
  'functions/resource-exhausted': 'Too many requests. Please try again later.',
  'functions/invalid-argument': 'Please check the details and try again.',
};

export const GENERIC_ERROR = 'Something went wrong. Please try again.';

// Callable errors arrive as 'not-found' (Firebase JS 7) or 'functions/not-found' (later SDKs).
export function callableCode(error) {
  return error && typeof error.code === 'string' ? error.code.replace(/^functions\//, '') : '';
}

export function friendlyAuthMessage(error) {
  if (!error || typeof error.code !== 'string') return GENERIC_ERROR;
  const code = error.code.startsWith('auth/') || error.code.startsWith('app/')
    ? error.code
    : `functions/${callableCode(error)}`;
  return MESSAGES[code] || GENERIC_ERROR;
}
